import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from '../../business-services/appointment.service';
import { OnHoldReasonList } from '../../business-entities/onHold-reason-list-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Subscription } from 'rxjs';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';


@Component({
  selector: 'app-cancel-status-change',
  templateUrl: './cancel-status-change.component.html'

})
export class CancelStatusChangeComponent implements OnInit {
  onHoldStatusReasonList: OnHoldReasonList[];
  selectedReasonId: number;
  @Input() appointmentId: number;
  @Input() workOrderNumber: string;
  @Input() appointmentType: string;
  @Input() appointmentGuid: string;
  @Input() isLockedByOtherUser: boolean = false;
  @Input() brandCode: string;
  features: Features[] = [];
  integrationWithDMS: boolean = false;
  realtimeDmsSyncAppointment: boolean = false;
  subscription: Subscription;

  constructor(private activeModal: NgbActiveModal,
    private appointmentService: AppointmentService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getFeatures();
    this.getReasonList();
  }
  getReasonList() {
    let langCode = this.cookieservice.get('userSelectedLanguage')
    this.appointmentService.GetOnHoldStatusReasonList(langCode, Enums.ReasonType.Cancel).then(data => {
      let response = data.responseObject
      if (response?.errorCount === 1) {
        this.onHoldStatusReasonList = [];
      }
      else {
        this.onHoldStatusReasonList = this.onHoldStatusReasonListDataMapper(data.responseObject);
      }
    });
  }

  reasonCheckboxChange(reasonId: number, index: number, isSelected: boolean) {
    if (isSelected) {
      this.selectedReasonId = reasonId;
      this.onHoldStatusReasonList.forEach((x, _i) => {
        if (x.reasonId !== reasonId) {
          x.isSelected = false;
        }
      });
      this.onHoldStatusReasonList[index].isSelected = true;
    }
    else {
      this.selectedReasonId = null;
    }
  }

  private onHoldStatusReasonListDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = 1 + index;
        single.reasonId = element.reasonId;
        single.reason = element.reason;
        single.isDescriptionRequire = element.isDescriptionRequire;
        single.isSelected = false;
        single.description = null;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onCrossClickModel() {
    this.activeModal.close({
      success: true,
      isKeepOnHold: false
    });
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        this.updateFeatureFlagValue();
      })
    }
    this.updateFeatureFlagValue();
  }
  updateFeatureFlagValue() {
    if (this.features?.length > 0) {
      this.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      this.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
    }
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  submitCancellationDetails() {
    this.spinner.show();
    let errorMsg = this.translate.instant("lblDescriptionRequire");
    let selectedReason = this.onHoldStatusReasonList.filter(x => x.reasonId === this.selectedReasonId)[0];
    if (selectedReason.isDescriptionRequire && !selectedReason.description) {
      this.toaster.error(errorMsg);
      this.spinner.hide();
    }
    else {
      this.spinner.hide();
      let modelHeadermsg = this.translate.instant("lblDelete");
      let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblAppointment"), true);
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        if (reason) {
          let viewmodel = {
            WorkOrderStatusId: Enums.WOStatus.Cancelled,
            AppointmentGuid: this.appointmentGuid,
            AppointmentId: this.appointmentId,
            IFSWorkOrderNumber: this.workOrderNumber,
            ModuleId: Enums.ModuleNames.Appointment,
            IntegrationWithDMS: this.integrationWithDMS,
            realtimeDmsSyncAppointment: this.realtimeDmsSyncAppointment,
            InvoicePrice: 0,
            CustomerGuid: "",
            ReasonForCancellation: selectedReason.isDescriptionRequire ? selectedReason.description : selectedReason.reason,
            BrandCode: this.brandCode,
          }

          if (this.appointmentType == "Quote") {
            viewmodel.IntegrationWithDMS = false;
            viewmodel.realtimeDmsSyncAppointment = false;
          }
          this.spinner.show()
          this.appointmentService.UpdateAppointmentStatus(viewmodel).then((res) => {
            this.spinner.hide();
            if (res.responseObject?.errorCount) {
              let errorMessage = this.translate.instant("lblInvalidParameter");
              this.toaster.error(errorMessage);
              this.onCrossClickModel();
              this.spinner.hide();
            }
            else if (res.responseObject?.isSuccess) {
              if(!this.empty(res.responseObject.resultMessage)){
                this.toaster.error(res.responseObject.resultMessage);
              }

                let successMessage = this.translate.instant("lblCancellationStatusUpdated");
                this.toaster.success(successMessage);
                this.activeModal.close({
                  success: true,
                  isKeepOnHold: true
                });
                this.spinner.hide();

              }
              else {
                let errorMessage = this.translate.instant("lblCancellationStatusUpdateFailed");
                this.toaster.error(errorMessage);
                this.onCrossClickModel();
                this.spinner.hide();
              }
          })
        }
      });
    }
  }
}
